<template>
  <div>
    <hshead title="修改密码" bgcolor="#fff"></hshead>
    <div>
      <van-cell-group>
        <van-field
          v-model="tempData.old_pwd"
          label="旧密码"
          placeholder="请输入旧密码"
          maxlength="20"
        />
        <van-field
          v-model="tempData.new_pwd"
          label="新密码"
          placeholder="请输入新密码(6至20位数字或字母)"
          maxlength="20"
        />
        <van-field
          v-model="tempData.new_pwd2"
          label="确认密码"
          placeholder="再次输入新密码"
          maxlength="20"
        />
      </van-cell-group>
      <van-cell>
        <van-button type="info" size="large" class="my-btn" @click="handleModifyPwd">确定修改</van-button>
      </van-cell>
    </div>
  </div>
</template>

<script>

import hshead from "@/components/common/hshead";
import { Toast, List, CellGroup, Cell, Field, Button } from "vant";
import { modifyPwd } from "@/api/m/user";

export default {
  name: "modifyPwd",
  data() {
    return {
      tempData: {},
    };
  },
  methods: {
    handleModifyPwd() {
      const { old_pwd, new_pwd, new_pwd2 } = this.tempData
      if(!old_pwd || !new_pwd || !new_pwd2) {
        this.tips(`请输入密码`);
        return
      }
      if(new_pwd.length < 6 || new_pwd2.length < 6) {
        this.tips(`新密码不能少于6位数`);
        return
      }
      if(new_pwd != new_pwd2) {
        this.tips(`两次输入的密码不一致`);
        return
      }
      const param = {
        old_pwd,
        new_pwd
      }
      console.info('param', param)
      this.load(true, '加载中...');
      modifyPwd(param).then(response => {
        this.load(false);
        const { code, msg, data } = response;
        if (code >= 0) {
          this.tips(`操作成功`);
        }
      }).catch(response => {
        this.load(false);
        //this.tips(response.msg);
        Toast.fail({duration:1000 * 5, message: `${response.msg}`});
      });
    }
  },
  components: {
    hshead,
    "van-list": List,
    "van-cell-group": CellGroup,
    "van-cell": Cell,
    "van-field": Field,
    "van-button": Button
  }
};
</script>

<style lang="less" scoped>
// @import "~@/assets/less/common.less";
// @import "~@/assets/less/mixin.less";
.my-btn {
  border-radius: 1rem !important;
  background-color: #00b8f5 !important;
  font-size: 14px !important;
  border-color: transparent;
  height: 35px;
  line-height: 35px;
}
</style>


// WEBPACK FOOTER //
// src/views/user/modifyPwd.vue